module.exports = __webpack_public_path__ + "static/media/AutoCAD.6d672aad.png";